import { ASSISTED_TRANSFER } from '../../constants.js';

export function newAssistedTransferState(newState) {
  return {
    type: ASSISTED_TRANSFER.CHANGE_STATE,
    currentState: newState
  };
}


// WEBPACK FOOTER //
// ./src/redux/actions/A_assisted_transfer.js